import Vue from 'vue';
/* 全局事件总线 */
export default new Vue();



// WEBPACK FOOTER //
// ./src/utils/bus.js